import defineComponent from 'flight';

function CategoriesSectionUI() {
    this.OPEN_CLASS = 'open';

    this.defaultAttrs({
        toggleButton: '[data-nav-categories-sub]',
        categorySection: '.view-categories-category'
    });

    this._toggleSubcategories = function (e) {
        e.preventDefault();
        this.$node.toggleClass(this.OPEN_CLASS);
    };

    this.after('initialize', function () {
        this.on('click', {
            toggleButton: this._toggleSubcategories
        });
    });
}

module.exports = defineComponent.component(CategoriesSectionUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/categories-section-ui.js